var loader;

export default {
    data() {
        return {
            isLoading: false
        }
    },

    beforeMount() {
        loader = this;
    },

    created() {
        this.$loader.$on('load', () => {
            loader.isLoading = true;
            loader.$forceUpdate();
        });
        
        this.$loader.$on('stop', () => {
            loader.isLoading = false;
            loader.$forceUpdate();
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/Loader.js